"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiSetStudentMeta = exports.apiGetAvailableStudentName = exports.apiGenerateStudentPdf = exports.apiActivateStudent = exports.apiVerifyStudentActivation = exports.apiResetStudentPassword = exports.apiVerifyStudentPasswordReset = exports.apiRequestStudentPasswordReset = exports.apiUpdateStudent = exports.apiRemoveStudentFromCourse = exports.apiAddStudentToCourse = exports.apiGetCourseStudents = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
/**
 * Get the students for the given course.
 * @param courseId
 * @returns the students of the course.
 */
const apiGetCourseStudents = async (courseId) => {
    const { data } = await client_1.default.get(`/courses/student/get-students/${courseId}`);
    return data;
};
exports.apiGetCourseStudents = apiGetCourseStudents;
/**
 * Add a new student to the course.
 * The name will be auto-generated.
 * @param courseId the course to add the student to
 * @returns the new student
 */
const apiAddStudentToCourse = async (courseId) => {
    try {
        const { data } = await client_1.default.post(`/courses/student/add-student/${courseId}`);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiAddStudentToCourse = apiAddStudentToCourse;
/**
 * Remove a student from the course.
 * @param courseId the course to remove the student from.
 * @param studentId the student to remove
 */
const apiRemoveStudentFromCourse = async (courseId, studentId) => {
    try {
        await client_1.default.delete(`/courses/student/remove-student/${courseId}/${studentId}`);
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiRemoveStudentFromCourse = apiRemoveStudentFromCourse;
/**
 * Update a student in a course.
 * @param courseId The course of the student
 * @param studentId The student to update
 * @param loginName The new loginName of the student
 * @param reminder The reminder of the student.
 * @returns the newly updated student.
 */
const apiUpdateStudent = async (courseId, studentId, loginName, reminder) => {
    const { data } = await client_1.default.put(`/courses/student/update-student/${courseId}/${studentId}`, {
        loginName,
        reminder,
    });
    return data;
};
exports.apiUpdateStudent = apiUpdateStudent;
/**
 * Reset the student account
 * @param studentId
 */
const apiRequestStudentPasswordReset = async (studentId) => {
    const { data } = await client_1.default.post(`/courses/student/request-student-password-reset/${studentId}`);
    return data;
};
exports.apiRequestStudentPasswordReset = apiRequestStudentPasswordReset;
/**
 * Verify if a student is eligible for a password reset
 * @param token The student to verify
 * @returns true if allowed to reset, false otherwise
 */
const apiVerifyStudentPasswordReset = async (token) => {
    const { data } = await client_1.default.get(`/courses/student/verify-student-password-reset/${token}`);
    return data;
};
exports.apiVerifyStudentPasswordReset = apiVerifyStudentPasswordReset;
/**
 * Reset the password of a student
 * @param token reset token
 * @param newPassword new student password
 * @returns the student's id
 */
const apiResetStudentPassword = async (token, newPassword) => {
    const { data } = await client_1.default.post('/courses/student/reset-student-password/', {
        token,
        newPassword,
    });
    return data;
};
exports.apiResetStudentPassword = apiResetStudentPassword;
/**
 * Verify if a student is eligible activation
 * @param token The student to verify
 * @returns true if allowed to activate, false otherwise
 */
const apiVerifyStudentActivation = async (token) => {
    const { data } = await client_1.default.get(`/courses/student/verify-student-activation/${token}`);
    return data;
};
exports.apiVerifyStudentActivation = apiVerifyStudentActivation;
/**
 * Sets a new password for the student
 * @param studentId The student to set new password
 * @param initialPassword The intital password to set
 * @returns The Student
 */
const apiActivateStudent = async (studentId, initialPassword) => {
    const { data } = await client_1.default.post(`/courses/student/activate-student/${studentId}`, { newPassword: initialPassword });
    return data;
};
exports.apiActivateStudent = apiActivateStudent;
/**
 * Generates a student PDF for the given purpose
 * @param studentId the student
 * @param url the url to be turned into a QR code and inserted into the pdf
 * @param purpose specifies if the PDF relates to activation or passwordReset
 */
const apiGenerateStudentPdf = async (studentId, url, purpose) => {
    try {
        const { data } = await client_1.default.post(`/courses/student/generate-student-pdf/${studentId}`, {
            url,
            purpose,
        });
        return data;
    }
    catch (error) {
        throw (0, util_1.handleError)(error);
    }
};
exports.apiGenerateStudentPdf = apiGenerateStudentPdf;
/**
 * Get a available student name for the given course.
 * @param courseId The course to get a available name for.
 * @returns A available name for a student.
 */
const apiGetAvailableStudentName = async (courseId) => {
    try {
        const { data } = await client_1.default.get(`/courses/student/available-name/${courseId}`);
        return data;
    }
    catch (err) {
        throw (0, util_1.handleError)(err);
    }
};
exports.apiGetAvailableStudentName = apiGetAvailableStudentName;
/**
 * Set the meta-data for the student.
 * @param meta
 * @returns the updated student.
 */
const apiSetStudentMeta = async (meta) => {
    const { data } = await client_1.default.put('/courses/student/set-meta', Object.assign({}, meta));
    return data;
};
exports.apiSetStudentMeta = apiSetStudentMeta;
//# sourceMappingURL=students.js.map